import { Card, CardContent, CardHeader, CardTitle } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const PreviewSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('flex-between gap-4 border-b', className);

	// Render
	return (
		<Card size='sm' className={rootClassName}>
			<span className='flex-start grow gap-4 w-full'>
				<CardHeader className='aspect-[1/1] rounded-control shrink-0 w-12'>
					<Skeleton className='h-full w-full leading-[inherit]' />
				</CardHeader>
				<CardContent className='gap-2 w-full'>
					<CardTitle className='w-1/2'>
						<Skeleton />
					</CardTitle>
				</CardContent>
			</span>
		</Card>
	);
};
export { PreviewSkeleton };
// Docs:
// https://github.com/dvtng/react-loading-s#readme
